import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getDivisionByEstateID,
    GetBlockPluckingReportData,
    GetAllOperationEntityByGroupID,
    GetFieldsByCollectionPointID,
    GetActiveAspNetUser
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function GetFieldsByCollectionPointID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["fieldID"]] = item[1]["fieldName"]
        }
    }
    return divisionArray;

}

async function GetBlockPluckingReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        fromDate: data.fromDate,
        toDate: data.toDate
    };
    const response = await CommonPost('/api/FieldPerformanaceAnalysisReport/GetDataForFieldPerformanaceAnalysis', null, model);
    return response.data;
}

async function GetActiveAspNetUser(groupID, operationEntityID) {

    var FilterUserModel = {
        groupID: groupID,
        operationEntityID: operationEntityID
    }
    var response = await CommonPost('/api/User/GetActiveUser', null, FilterUserModel);

    return response;

}